import React from 'react';

const Error = () => (
    <div>
        <header className="section error" id="page-title">
            <h1>Activation Error</h1>
        </header>

        <section className="section error" id="enter-code">
            <h2>Your device could not be activated!</h2>
            <p>Please verify the code you entered matches the code on your device and try again.</p>
            <p>If you continue to receive this message please try generating a new code on the device.</p>
        </section>
    </div>
);

export default Error;



// WEBPACK FOOTER //
// ./app/webapp/page/Activate/Error.js